import { memo } from "react";

import { PercentageDisplay } from "commonComponents/financial/PercentageDisplay/PercentageDisplay";
import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";

function columnPercentageInternal(props: IGridCellRendererParams) {
    const { value, className } = props;

    if (value === null || value === undefined) {
        return null;
    }

    return (
        <PercentageDisplay
            value={value}
            decimalScale={2}
            className={className}
            data-testid={`ag-grid-col-percentage.${props.colDef?.field}.${props.node.rowIndex!}`}
        />
    );
}

export const columnPercentage = memo(columnPercentageInternal);
